import { ShimmerPostList } from "react-shimmer-effects";

const YourComponent = () => {
  return <ShimmerPostList postStyle="STYLE_FOUR" col={3} row={2} gap={30} />;
};


export default YourComponent;